import { ref, computed, watch, onMounted } from "vue";
import { defineStore } from "pinia";
import { useStorage } from '@vueuse/core'
import { usePreferredLanguages } from '@vueuse/core'
import { useGettext } from 'vue3-gettext'

export const useApplicationStore = defineStore("application", () => {

    const loading = ref(false);
    const name = ref("");
    const title = ref("");
    const subtitle = ref("");
    const currentLocale = useStorage('currentLocale');
    const availableLocales = ref(['de', 'en']);
    const defaultLocale = ref('en');
    const utmParameters = useStorage('utmParameters', {});
    const currentReading = useStorage('currentReading', null);
    const gettext  = useGettext();

    onMounted(() => {
        if (!currentLocale.value) {
            const preferredLanguages = usePreferredLanguages();
            const uniqueLanguages = [...new Set(preferredLanguages.value.map(lang => {
                return lang.split("-")[0];
            }))];
            const mostPreferredLanguage = uniqueLanguages.find(lang => availableLocales.value.includes(lang)) || defaultLocale.value;
            
            setCurrentLocale(mostPreferredLanguage);
        }

        watch(currentLocale, (newLocale) => {
            gettext.current = newLocale;
        }, { immediate: true });
    });


    
    function setLoading(value) {
        loading.value = value;
    }

    function setName(value) {
        name.value = value;
    }

    function setCurrentLocale(value) {
        currentLocale.value = value;
    }

    function setTitle(value) {
        title.value = value;
    }

    function setSubtitle(value) {
        subtitle.value = value;
    }

    function setCurrentReading(value) {
        currentReading.value = value;
    }

    function setCurrentLocale(value) {
        currentLocale.value = value;
    }


    function setUtmParameters(query) {
        try {
            if (query) {
                const newUtmParams = Object.keys(query).reduce((acc, key) => {
                    if (key.startsWith('utm_') && query[key]) {
                        acc[key.replace('utm_', '')] = query[key];
                    }
                    return acc;
                }, {});

                // Only update if we found UTM parameters
                if (Object.keys(newUtmParams).length > 0) {
                    utmParameters.value = newUtmParams;
                }
            }
        } catch (e) {
            console.error('Error:', e);
        }
    }

    return {
        loading,
        name,
        title,
        subtitle,
        currentLocale,
        utmParameters,
        currentReading,
        setTitle,
        setSubtitle,
        setName,
        setLoading,
        setCurrentLocale,
        setUtmParameters,
        setCurrentReading
    }
})